import { Divider, Icon, Popover } from "@material-ui/core";
import { Fragment, useEffect, useRef, useState } from "react";

export default function PopoverMenu({
  item,
  classes,
  parseTitle,
  className,
  popoverId,
  activePopover,
  setActivePopover,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const handleMouseEnter = (e) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setAnchorEl(e.currentTarget);
    setActivePopover(popoverId);
  };

  const handleMouseLeave = () => {
    timerRef.current = setTimeout(() => {
      setAnchorEl(null);
      setActivePopover(null);
    }, 300);
  };

  const open = activePopover === popoverId && Boolean(anchorEl);
  return (
    <>
      <a
        href={item.url}
        className={className}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        role="button"
        aria-haspopup="true"
        aria-expanded={open}
      >
        {parseTitle(item.title)}{" "}
        <Icon>{open ? "arrow_drop_up" : "arrow_drop_down"}</Icon>
      </a>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setActivePopover(null);
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        disableRestoreFocus
        PaperProps={{
          onMouseEnter: () => {
            if (timerRef.current) clearTimeout(timerRef.current);
          },
          onMouseLeave: () => {
            setAnchorEl(null);
            setActivePopover(null);
          },
        }}
        className={classes.popoverContainer}
      >
        <div
          className={classes.popoverContent}
          role="menu"
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              setAnchorEl(null);
              setActivePopover(null);
            }
          }}
        >
          {item.submenu &&
            item.submenu.map((subItem, index) => (
              <Fragment key={index}>
                <a
                  tabIndex={0}
                  role="menuitem"
                  href={subItem.url}
                  className={classes.popoverLink}
                >
                  {parseTitle(subItem.title)}
                </a>
                <Divider />
              </Fragment>
            ))}
        </div>
      </Popover>
    </>
  );
}
